<template lang="pug">
  .main-container
    .upload(v-if="isNew")
      Upload Forms
    .manage(v-else)
      FormPage()

</template>
<script>
import IQToolMiddlePaneHeader from '@/pages/IQTools/Partials/IQToolMiddlePaneHeader/IQToolMiddlePaneHeader.vue';
import Upload from './Upload.vue';
import FormPage from './FormPage.vue';
import EditArea from '@/components/EditArea.vue';

export default {
  name: 'ManageForms',
  components: {
    IQToolMiddlePaneHeader,
    Upload,
    EditArea,
    FormPage,
  },
  data() {
    return {
      baseTranslationPath: 'iq_tools_tab.forms_tab.manage',
    };
  },
  computed: {
    // Derive from the route synchronously so FormPage is never mounted for the
    // "new" route (child mounts run before the parent's, so a mounted() flag
    // would let FormPage.init() fire getForm('new') -> 404 -> redirect away).
    isNew() {
      return this.$route.params.id === 'new';
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./../../../styles/aiq-variables.scss";

.upload {
  width: 100%;
  background-color: $aiq-bgc-list-item;
  margin-left: 4px;
  margin-right: 4px;
}

.manage {
  width: 100%;
  background-color: $aiq-bgc-list-item;
  margin-left: 4px;
  margin-right: 4px;
}

</style>
